import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PreloadData,
} from "@insite/client-framework/Store/Pages/OrderConfirmation/Handlers/PreloadOrderConfirmationData";
import loadExpediteShipping from "@TKCCP/Store/Data/ExpediteShipping/Handlers/LoadExpediteShipping";

addToChainAfter(chain, PreloadData, props => {
    if (props.parameter) {
        props.dispatch(loadExpediteShipping({ cartId: props.parameter.cartId }));
    }
});
